export const batch = [
    {
        cols: [
            {
                content: {
                    html: 'Text',
                    style: {},
                },
                style: {},
            },
        ],
    },
];

export default batch;
